var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
let FormElementComponent = class FormElementComponent extends GGOBaseComponent {
    static { this.properties = {
        label: { type: String },
    }; }
    static get styles() {
        return [
            ...super.styles,
            css `
        .ggo-card {
          margin-top: 1rem;
        }
      `,
        ];
    }
    constructor() {
        super();
        this.title = '';
        //this.rename = (event: CustomEvent) => {};
    }
    render() {
        return html `<div class="slds-form-element slds-form-element_horizontal">
      <label class="slds-form-element__label" for="horizontal-input-id-01">${this.label}</label>
      <div class="slds-form-element__control">
        <slot></slot>
      </div>
    </div>`;
    }
};
FormElementComponent = __decorate([
    customElement('ggo-form-element')
], FormElementComponent);
export { FormElementComponent };
